import { render, staticRenderFns } from "./layout-image-orange.vue?vue&type=template&id=39edb6b9&scoped=true&"
import script from "./layout-image-orange.vue?vue&type=script&lang=js&"
export * from "./layout-image-orange.vue?vue&type=script&lang=js&"
import style0 from "./layout-image-orange.vue?vue&type=style&index=0&id=39edb6b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39edb6b9",
  null
  
)

export default component.exports